import {get_local, set_local} from "../helpers";

export default {
  template: '#vue-login',
  delimiters: ['${', '}'],
  data: function () {
    return {
      recovery_email: get_local('recovery_email')
    }
  },
  methods: {
    submitReset: function (e) {
      set_local('recovery_email', this.recovery_email);
    }
  }
}